import redux from './redux';
import * as apis from './apis';
import ApiManager from './classes/ApiManager';

import OHIF from 'ohif-core';

const api = { redux, apis };
OHIF.api = api;

export { apis, redux, ApiManager };
export default api;
